import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { SearchService } from '@services/search.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { AddService } from '@services/add.service';
import { ViewService } from '@services/view.service';
import * as _ from 'lodash';
import { rotateInDownLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-maudio',
  templateUrl: './maudio.component.html',
  styleUrls: ['./maudio.component.sass'],
  animations: [
    rotateInDownLeftOnEnterAnimation({ anchor: 'searchPage' })
  ]
})
export class MaudioComponent implements OnInit {

  response: any = [];
  pageCounter = 1;
  totalRecord = 0;
  application = "audio";
  component = 'm';
  rows = 1;
  searchtxt="";
  params: any = [];
  total_record = 0;
  pageno = 1;
  dataLoding = true;
  playLists:any=[];
  playList_btn_process=false;
  playListAudioListForm:FormGroup;
  audioListForm:FormGroup;
  playListAudioList:any=[];
  playList = "null";
  router_param:any=[];
  playList_response:any=[];
  constructor(private _addService: AddService, private _viewService: ViewService, private fb: FormBuilder,private router: Router, private route: ActivatedRoute, private _searchService: SearchService, private _global: GlobalService) {
    this.rows = this._global.ROWS;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.audioListForm = this.fb.group({
      list: new FormArray([])
    });
    this.playListAudioListForm = this.fb.group({
      list: new FormArray([])
    });
    this.route.queryParams.subscribe(params => {
      this.router_param = params;
      if (this.router_param['playlistid']) {
        this.playList = this.router_param['playlistid'];
        this.getPlayList()
      }
    });
    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      sortOrder: 'desc',
      sortString: 'createdTime',
      createdBy:this._global.getSessionVal('id'),
      rows: this.rows
    };
    /* this.route.queryParams.subscribe(params => {
      Object.entries(params).forEach(([key, value]) => {
        if (value) {
          p[key] = value;
        }
      });
    }); */

    this.loadAppData(p);
    this.loadPlayList();

  }

  ngOnInit() {
    /* const queryParams = this.route.snapshot.queryParams
    const routeParams = this.route.snapshot.params; */
  }

  loadPlayList() {
    let p = {
      component: this.component,
      application: 'playList',
      start: 0,
      sortOrder: 'desc',
      sortString: 'createdTime',
      createdBy: this._global.getSessionVal('id'),
      rows: this.rows
    };
    this._searchService.memberApplication(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.playLists = this._global.getVal(data, 'response.docs', []);
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }


  loadAppData(p) {
    this.dataLoding = true;
    this._searchService.memberApplication(p).subscribe(
      data => {
        this.dataLoding = false;
        this.params = this._global.getVal(data, 'request', '');
        this.response = data["response"]["docs"];
        Object.entries(this.response).forEach(([key, value]) => {
          let control = this.fb.control('');
          (this.audioListForm.controls.list as FormArray).push(control);
        });
        this.total_record = this._global.getVal(data, 'response.numFound', '0');
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  onScrollDown() {
    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.total_record <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._searchService.memberApplication(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.response = this.response.concat(data["response"]["docs"]);
              Object.entries(data["response"]["docs"]).forEach(([key, value]) => {
                let control = this.fb.control('');
                (this.audioListForm.controls.list as FormArray).push(control);
              });
              this.dataLoding = false;
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
            }else{
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });
        //  console.log('scrolled down!!', ev);

      }
    }
  }
  searchMedia(event: any) {
    this.dataLoding = true;
    this.response=[];
    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      name: this.searchtxt,
      sortOrder: 'desc',
      sortString: 'createdTime',
      createdBy: this._global.getSessionVal('id'),
      rows: this.rows
    };
    this.loadAppData(p);
  }
  getPlayList(){
    this.playListAudioList = [];
    this.playList_response=[];
    this.dataLoding = true;
    this.playListAudioListForm = this.fb.group({
      list: new FormArray([])
    });
    if (this.playList!="null") {
      let p = {
        'component': this.component,
        'application': 'playList',
        'id': this.playList
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.playList_response = this._global.getVal(data, 'response', '');
            Object.entries(this.playList_response['audio']).forEach(([key, value]) => {
              value = this._global.asJsonObject(value);
              let r = {
                mediaType: "audio",
                uid: key,
                id:key,
                name: value['name']
              }
              this.playListAudioList.push(r);
              let control = this.fb.control(true);
              (this.playListAudioListForm.controls.list as FormArray).push(control);
            });
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });

    }
  }
  playListAdd() {
    this.playList_btn_process = true;
    let r = {};
    r['component'] = this.component;
    r['application'] = 'playList';
    r['id'] = this.playList;
    if(this.playList!='null'){
    let ids = [];
    Object.entries(this.audioListForm.value['list']).forEach(([key, value]) => {
      if (value) {
        ids.push(this.response[key]['id']);
      }
    });
    Object.entries(this.playListAudioListForm.value['list']).forEach(([key, value]) => {
      if (value) {
        ids.push(this.playListAudioList[key]['id']);
      }
    });
    r['mediaIds'] = ids.join(",");
    r = this._global.paramsRemoveNull(r);
   this._addService.application(r).subscribe(
      data => {
        this.playList_btn_process = false;
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ type: severity, message: message });
        } else {
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          this._global.showMessage({ type: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      }); 
    }else{
      this.playList_btn_process = false;
      this._global.showMessage({ type: 'warning', message: 'Please Choose the playList' });
    }
  }
}

